import request from './request';

const paymentService = {
  getAll: (params) => request.get('dashboard/admin/payments', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/payments/${id}`, { params }),
  update: (id, data) => request.put(`dashboard/admin/payments/${id}`, data),
  setActive: (id) =>
    request.post(`dashboard/admin/payments/${id}/active/status`, {}),

  // Payment Modes services
  getAllModes: () => request.get('dashboard/admin/payments-mode/'),
  getModeById: (id) => request.get(`dashboard/admin/payments-mode/${id}`),
  togglePaymentMode: (id, field) =>
    request.post(`dashboard/admin/payments-mode/toggle/${id}`, { field }),
};

export default paymentService;
